import { useState } from "react";
import { usePortal } from "../../../context/PortalContext";
import { PORTALS } from "../../../utils/portalTypes";
import authAPI from "../../../services/authApi";
import AuthShell from "./AuthShell";
import AuthField from "./AuthField";
import Button from "../../ui/Button";
import AuthButtonLink from "../Auth/AuthButtonLink";
import a from "./auth.module.css";

export default function PortalForgotPasswordPage({ portal = PORTALS.patient }) {
  const { subdomain, clinic } = usePortal();
  const clubName = clinic?.name || null;
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devUrl, setDevUrl] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const loginPath =
    portal.id === "admin"
      ? "/manage/login"
      : portal.id === "staff"
        ? "/staff/login"
        : "/login";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await authAPI.forgotPassword(email.trim(), subdomain);
      if (r.result === 0) {
        setSent(true);
        if (r.devResetUrl) setDevUrl(r.devResetUrl);
      } else {
        setErr(r.message || r.error || "Ошибка");
      }
    } catch (e) {
      setErr(e.response?.data?.error || "Ошибка запроса");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      modern
      backTo={loginPath}
      backLabel="К входу"
      showSwitcher={false}
      cardTitle={sent ? "Запрос принят" : "Сброс пароля"}
      hint={
        sent
          ? "Если аккаунт существует, администратор клуба поможет восстановить доступ. В dev-режиме ссылка ниже."
          : `Укажите email аккаунта ${portal.title.toLowerCase()}.`
      }
      clubTag={clubName}
    >
      {sent ? (
        <>
          {devUrl ? (
            <p className={a.infoBox}>
              Dev: <a href={devUrl}>ссылка</a>
            </p>
          ) : null}
          <div className={a.actions}>
            <AuthButtonLink to={loginPath}>Вернуться ко входу</AuthButtonLink>
          </div>
        </>
      ) : (
        <form onSubmit={submit}>
          {err ? <div className={a.errorBox}>{err}</div> : null}
          <AuthField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={loading}>
              {loading ? "Отправка…" : "Запросить сброс"}
            </Button>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
